export const LIGHTEST_BLUE = "#E6F7FF";
export const LIGHT_BLUE = "#0084F4";
export const PRIMARY_BLUE = "#384DF6";
export const PRIMARY_GREEN = "#30606B";
export const SUCCESS_GREEN = "#389E0D";
export const ACTION_BLUE = "#1890FF";
export const INDIGO = "#1890ff";
